"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var context_1 = require("../context");

var createErrorCbMap = function createErrorCbMap(setStep, setError) {
  return {
    'auth/invalid-email': function authInvalidEmail(e) {
      setError(e.message);
      setStep(0);
    },
    'auth/email-already-in-use': function authEmailAlreadyInUse(e) {
      setError(e.message);
      setStep(0);
    },
    'auth/weak-password': function authWeakPassword(e) {
      setError(e.message);
      setStep(1);
    },
    'auth/user-not-found': function authUserNotFound() {
      return setStep(2);
    }
  };
};

exports.default = function (onSuccess) {
  var xya = context_1.useXyAccountContext(); // const [isRegistering, setIsRegistering] = useState(false)

  var _a = react_1.useState(0),
      step = _a[0],
      setStep = _a[1];

  var _b = react_1.useState(false),
      loading = _b[0],
      setLoading = _b[1];

  var _c = react_1.useState(''),
      error = _c[0],
      setError = _c[1];

  var _d = react_1.useState(''),
      email = _d[0],
      setEmail = _d[1];

  var _e = react_1.useState(''),
      password = _e[0],
      setPassword = _e[1];

  var _f = react_1.useState(''),
      passwordConfirmation = _f[0],
      setPasswordConfirmation = _f[1];

  var errorCbMap = createErrorCbMap(setStep, setError);

  var handleSubmitEmail = function handleSubmitEmail() {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!email) return [2
        /*return*/
        , setError('Email is required')];
        setStep(1);
        return [2
        /*return*/
        ];
      });
    });
  };

  var handleSubmitPassword = function handleSubmitPassword() {
    // if (isRegistering) return setStep(2)
    return handleSignIn();
  };

  var handleSignIn = function handleSignIn() {
    setError('');
    setLoading(true);
    return Promise.resolve().then(function () {
      if (!xya) throw new Error('No XY Account provider');
      return xya.signIn(email, password);
    }).then(function () {
      setLoading(false);
      onSuccess();
    }).catch(handleAuthError);
  };

  var handleConfirmPassword = function handleConfirmPassword() {
    setError('');
    setLoading(true);
    return Promise.resolve().then(function () {
      if (password !== passwordConfirmation) {
        setStep(1);
        setPassword('');
        setPasswordConfirmation('');
        throw new Error('Passwords do not match');
      }

      if (!xya) throw new Error('No XY Account provider');
      return xya.signUp(email, password);
    }).then(function () {
      setLoading(false);
      onSuccess();
    }).catch(handleAuthError);
  };

  var next = function next() {
    switch (step) {
      case 0:
        return handleSubmitEmail();

      case 1:
        return handleSubmitPassword();

      case 2:
        return handleConfirmPassword();

      default:
        return;
    }
  };

  var handleAuthError = function handleAuthError(e) {
    var errorCb = errorCbMap[e.code] ? errorCbMap[e.code] : function () {
      return setError(e.message);
    };
    setLoading(false);
    errorCb(e);
  };

  return {
    step: step,
    loading: loading,
    error: error,
    email: email,
    password: password,
    setEmail: setEmail,
    setPassword: setPassword,
    passwordConfirmation: passwordConfirmation,
    setPasswordConfirmation: setPasswordConfirmation,
    setStep: setStep,
    // isRegistering,
    next: next
  };
};